export default [
	{
		path: '/pages/asset/assetMap',
		meta: { title: '资产地图' },
		name: '/pages/asset/assetMap',
		component: () => import('@/views/asset/assetMap.vue'),
	},
	{
		path: '/pages/asset/assetLedger',
		meta: { title: '资产台账' },
		name: '/pages/asset/assetLedger',
		component: () => import('@/views/asset/assetLedger.vue'),
	},
	{
		path: '/pages/asset/assetDynamic',
		meta: { title: '资产动态' },
		name: '/pages/asset/assetDynamic',
		component: () => import('@/views/asset/assetDynamic.vue'),
	},
	{
		path: '/pages/asset/assetPlan',
		meta: { title: '资产规划' },
		name: '/pages/asset/assetPlan',
		component: () => import('@/views/asset/assetPlan.vue'),
	},
	{
		path: '/pages/asset/depreciationManage',
		meta: { title: '折旧管理' },
		name: '/pages/asset/depreciationManage',
		component: () => import('@/views/asset/depreciationManage.vue'),
	},
	{
		path: '/pages/asset/resourceManage',
		meta: { title: '资源管理' },
		name: '/pages/asset/resourceManage',
		component: () => import('@/views/asset/resourceManage.vue'),
	},
	{
		path: '/pages/asset/assetInventory',
		meta: { title: '资产盘点' },
		name: '/pages/asset/assetInventory',
		component: () => import('@/views/asset/assetInventory.vue'),
	},
];
